<style lang="scss" scoped>
.el-select-input {
    position: relative;

    .el-select-input-dropdown {
        background: #fff;
        position: absolute;
        top: 48px;
        min-width: 100%;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
        border-radius: 4px;
        background-color: #ffffff;
        border: none;
        z-index: 10;
        font-size: 1rem;
        max-height: 196px;
        overflow: auto;
        .category {
            padding: 12px 16px 0 16px;
        }
        .item {
            padding: 12px 16px;
            user-select: none;
            cursor: pointer;
            transition: 0.3s background;
            white-space: nowrap;
            &:hover,
            &.selected {
                background-color: rgba(40, 48, 72, 0.05);
            }
            &:last-child {
                border-radius: 0 0 2px 2px;
            }
        }
        &.top {
            border-radius: 2px 2px 0 0;
            top: auto !important;
            bottom: 55px;
        }
    }
}
label,
.label-error {
    margin-bottom: 0;
    background: #fff;
    left: 11px;
    top: 0px;
    padding: 0;
    color: var(--dark);
    font-weight: 400;
    line-height: 22px;
    display: flex;
}
.label-error {
    color: var(--danger);
}
.form-control:disabled,
.form-control[readonly] {
    background-color: #fff;
    opacity: 1;
}
</style>

<template>
    <div class="form-row">
        <div class="col-12 col-lg-3 form-group el-input el-select-input flex-wrap" :class="{ active : showOptions }" v-click-outside="() => { showOptions = false  }">
            <label v-if="!errors.has(name) && hasLabel" :for="_uid + 'Id'" class="small">
                {{ label }}
                <slot name="label-cta">

                </slot>
            </label>
            <span v-else-if="hasLabel" class="label-error small">{{ errors.first(name) }}</span>
            <el-input type="text" class="small mb-0" :hasLabel="false" :disabled="disabled" :class="{error : errors.has(name), 'mt-0' : !hasLabel}" v-model="search" @focus="showOptions = true" @keydown.tab="() => { showOptions = false}" :ref="refName" :rule="rule" :name="name" :id="name" :placeholder="placeholder" />
            <div v-if="showOptions" class="el-select-input-dropdown" :class="direction">
                <div v-for="category in filteredOptions" class="mb-8" :key="category.type">
                    <div class="category">
                        <small class="text-gray">{{$t('searchables.'+category[categoryKey])}}</small>
                    </div>
                    <div class="item text-primary-dark" :class="{selected : localValue.find(selected => category[categoryKey] === selected.type && option[valueKey] === selected.value) !== undefined }" v-for="(option, key) in category.values" :key="key" @click="update(category, option), showOptions = false" v-html="option[labelKey]"></div>
                </div>
            </div>
        </div>
        <div class="col-12 col-lg-9">
            <span class="d-inline-block py-8 px-16 bg-gray-light mx-8 mb-8 rounded c-pointer" @click="remove(item)" v-for="(item, index) in localValue" :key="index">{{ getOptionFromValue(item)[labelKey] }} <i-cross class="i-8 ml-8 fill-primary-dark"></i-cross></span>
        </div>
    </div>
</template>

<script>
import { ElInput } from '@/components/forms'

export default {
    inject: ["$validator"],
    components: { ElInput },
    props: {
        /**
         * String defining the value
         * @type {String, Object}
         */
        value: {
            type: Array,
            default: () => {
                return []
            }
        },

        /**
         * String defining the input name
         * @type {String}
         */
        name: {
            type: String,
            default: ""
        },

        /**
         * String defining the input label
         * @type {String}
         */
        label: {
            type: String,
            default: ""
        },

        /**
         * String defining the input placeholder
         * @type {String}
         */
        placeholder: {
            type: String,
            default: ""
        },

        /**
         * validation defining the rules to be applied
         * @type {String}
         */
        rule: {
            type: String,
            default: ""
        },

        refName: {
            type: String,
            default: ""
        },

        /**
         * Boolean that defines if we have label
         * @type {Boolean}
         */
        hasLabel: {
            type: Boolean,
            default: true
        },

        /**
         * Boolean that defines the input is disabled
         * @type {Boolean}
         */
        disabled: {
            type: Boolean,
            default: false
        },

        /**
         * String that defines the dropdown direction
         * @type {String}
         */
        direction: {
            type: String,
            default: "bottom"
        },

        /**
         * Boolean that defines if we have label
         * @type {Boolean}
         */
        options: {
            type: Array,
            default: () => {
                return [];
            }
        },

        categoryKey: {
            default: 'type'
        },
        valueKey: {
            default: 'value'
        },
        labelKey: {
            default: 'label'
        },
        translate: {
            default: false
        },
        canEdit: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            localValue: [],
            showOptions: false,
            search: ''
        };
    },
    methods: {
        update(category, option) {
            const selected = { type: category[this.categoryKey], value: option[this.valueKey] };
            if (!this.localValue.find(item => item.value === selected.value && item.type === selected.type)) {
                this.localValue.push(selected)
                this.$emit('input', this.localValue)
            }
        },
        hideOptions() {
            this.showOptions = false;
        },
        getOptionFromValue(value) {
            const category = this.options.find(category => category.type === value.type)
            if (category) {
                return category.values.find(option => option[this.valueKey] === value.value)
            }
        },
        remove(value) {
            this.localValue = this.localValue.filter(item => item !== value)
            this.$emit('input', this.localValue)
        }
    },
    computed: {
        filteredOptions() {
            if (!this.search) {
                return this.options
            }
            let filteredOptions = []
            this.options.forEach(categoryOption => {
                let newCategory = Object.assign({}, categoryOption)
                newCategory.values = newCategory.values.slice().filter(item => item[this.labelKey].toLowerCase().includes(this.search.toLowerCase())).map(item => {
                    let newItem = Object.assign({}, item)
                    const matchStart = newItem[this.labelKey].toLowerCase().indexOf(this.search.toLowerCase())
                    const matchEnd = matchStart + this.search.length
                    const matchedPart = newItem[this.labelKey].substring(matchStart, matchEnd)
                    newItem[this.labelKey] = newItem[this.labelKey].replace(matchedPart, matchedPart.bold())
                    return newItem
                })
                if (newCategory.values.length > 0) {
                    filteredOptions.push(newCategory)
                }
            })
            return filteredOptions
        }
    },
    watch: {
        value: function () {
            this.localValue = this.value
        }
    },
    directives: {
        'click-outside': {
            bind: function (el, binding, vNode) {
                // Provided expression must evaluate to a function.
                if (typeof binding.value !== 'function') {
                    const compName = vNode.context.name
                    let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`
                    if (compName) { warn += `Found in component '${compName}'` }

                    console.warn(warn)
                }
                // Define Handler and cache it on the element
                const bubble = binding.modifiers.bubble
                const handler = (e) => {
                    if (bubble || (!el.contains(e.target) && el !== e.target)) {
                        binding.value(e)
                    }
                }
                el.__vueClickOutside__ = handler

                // add Event Listeners
                if (document.getElementById('app'))
                    document.getElementById('app').addEventListener('click', handler, true)
            },

            unbind: function (el) {
                // Remove Event Listeners
                if (document.getElementById('app'))
                    document.getElementById('app').removeEventListener('click', el.__vueClickOutside__)

                el.__vueClickOutside__ = null

            }
        },
    },
};
</script>
